export default __webpack_public_path__ + "static/university-of-leeds-40df789cd4739919dc4064ee53df1713.png";